import { Box, Typography, Button } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { ImgBox } from 'views/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/location-module/LocationViewV2/components/HeroSection/HeroSection.styles';
import dynamic from 'next/dynamic';
import { MainWidgetV2 } from 'views/rebranded-module/common/components';

const BookNowOverlay = dynamic(() => import('views/rebranded-module/HomeViewV2/components/UI/BookNowOverlay').then(
  (file) => file.BookNowOverlay,
));

const HeroSection = (props) => {
  const {
    content,
    coverImage,
    title,
    // subtitle,
    initWidgetData,
    reservationData,
    reInitWidget,
  } = props;
  const [isOverlayOpen, setOverlayOpen] = useState(false);

  const getSizedImage = useAdabtiveMultiSizeImage();

  const heroAlt = content?.heroBackground?.alt ?? title;

  const heroImage = useMemo(
    () => ({
      src: coverImage
        ? getSizedImage(coverImage)
        : getSizedImage(content?.heroBackground),
      alt: coverImage ? title : heroAlt,
    }),
    [coverImage, content?.heroBackground, title, heroAlt],
  );

  const handleOpenOverlayBookingClick = (event) => {
    setOverlayOpen(true);
    event.currentTarget.blur(); // Remove focus immediately after click
  };

  return (
    <StyledBox>
      <Box className="HSBGContainer">
        <ImgBox image={heroImage} width="100%" height="100%" unoptimized />
      </Box>
      <Box className="HSBGPattern">
        <ImgBox
          image={{
            src: '/imgs/Rebranding/location-module/asphalt_bg.jpg',
            alt: content?.heroBackground?.alt || title,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Box className="HSBGGradient" />
      <Box className="HSContentContainer">
        <Typography variant="h3" component="h1" pb={2} textAlign="center">
          {title}
        </Typography>
        {/* <Typography variant="body2" component="p" className="HSText">
          {subtitle || content.heroSubtitle}
        </Typography> */}
        <Box className="HSWidgetContainer">
          <MainWidgetV2
            rentalWidgetInitData={initWidgetData}
            initRenderFullWidget
            reservationData={reservationData}
            reInitWidget={reInitWidget}
          />
        </Box>
      </Box>
      <Button
        variant="contained"
        color="primary"
        size="large"
        className="HSFixedButton"
        onClick={handleOpenOverlayBookingClick}>
        {content.bookToday}
      </Button>
      {isOverlayOpen && (
        <BookNowOverlay
          open={isOverlayOpen}
          rentalWidgetInitData={initWidgetData}
          onClose={() => setOverlayOpen(false)}
          reservationData={reservationData}
          reInitWidget={reInitWidget}
        />
      )}
    </StyledBox>
  );
};

export { HeroSection };
